package com.platforma.chat_domain.model

data class DraftDomain (
    val draftId: Long,
    val aiModelId: Long,
    val userId: Long,
    val chatId: Long,
    val text: String
)